import API from '../config/config';
import axios from 'axios';

// Use the same admin axios instance with token interceptor
const adminAxios = axios.create({
  baseURL: `${API.BASE_URL}/api/admin`
});

// Add auth token interceptor
adminAxios.interceptors.request.use(
  (config) => {
    const adminToken = localStorage.getItem('adminToken');
    if (adminToken) {
      config.headers.Authorization = `Bearer ${adminToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle token expiration
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('admin');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Dashboard Summary
export const getDashboardSummary = async () => {
  try {
    // Fix URL to match the backend route '/dashboard/summary'
    const response = await adminAxios.get('/dashboard/summary');
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard summary:', error);
    throw error;
  }
};

// Users Management
export const getAllUsers = async (page = 1, limit = 10, userType = null) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(userType && { userType })
    });
    
    const response = await adminAxios.get(`/users?${queryParams}`);
    return response.data;
  } catch (error) {
    console.error('Get all users error:', error);
    throw error;
  }
};

export const getUserById = async (userId) => {
  try {
    const response = await adminAxios.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Get user ${userId} error:`, error);
    throw error;
  }
};

export const updateUser = async (userId, userData) => {
  try {
    const response = await adminAxios.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error(`Update user ${userId} error:`, error);
    throw error;
  }
};

// Events Management
export const getAllEvents = async (page = 1, limit = 10) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit
    });
    
    const response = await adminAxios.get(`/events?${queryParams}`);
    return response.data;
  } catch (error) {
    console.error('Get all events error:', error);
    throw error;
  }
};

export const getEventById = async (eventId) => {
  try {
    const response = await adminAxios.get(`/events/${eventId}`);
    return response.data;
  } catch (error) {
    console.error(`Get event ${eventId} error:`, error);
    throw error;
  }
};

export const updateEvent = async (eventId, eventData) => {
  try {
    const response = await adminAxios.put(`/events/${eventId}`, eventData);
    return response.data;
  } catch (error) {
    console.error(`Update event ${eventId} error:`, error);
    throw error;
  }
};

// Event Check-ins
export const getEventCheckins = async (eventId, page = 1, limit = 10) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit
    });
    
    const response = await adminAxios.get(`/events/${eventId}/checkins?${queryParams}`);
    return response.data;
  } catch (error) {
    console.error(`Get checkins for event ${eventId} error:`, error);
    throw error;
  }
};

// Event Footages
export const getEventFootages = async (eventId) => {
  try {
    const response = await adminAxios.get(`/events/${eventId}/footages`);
    return response.data;
  } catch (error) {
    console.error(`Get footages for event ${eventId} error:`, error);
    throw error;
  }
};

// Upload Moments CSV
export const uploadMomentsCSV = async (eventId, file) => {
  try {
    const formData = new FormData();
    formData.append('csv', file);
    
    const response = await adminAxios.post(`/events/${eventId}/upload-moments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error(`Upload moments CSV for event ${eventId} error:`, error);
    throw error;
  }
};
